import { useState, useEffect } from 'react';
import { money, modoTraslado, setModoTraslado } from '../util';
import Toggle from '../Toggle';

export default function TabProductos({ event, api, reload }) {
  const [editing, setEditing] = useState(null); // lot | 'new' | null
  const [groups, setGroups] = useState([]);
  const [groupSel, setGroupSel] = useState('');
  const [applying, setApplying] = useState(false);
  const [presaleVal, setPresaleVal] = useState(toLocalInput(event.sales_start_at));
  const [presaleSaved, setPresaleSaved] = useState(false);
  const lots = event.lots || [];

  useEffect(() => { api.get('/api/lot-groups').then(setGroups).catch(() => {}); }, []); // eslint-disable-line

  async function savePresale(clear) {
    const iso = clear ? null : (presaleVal ? new Date(presaleVal).toISOString() : null);
    try {
      await api.patch(`/api/events/${event.id}`, { sales_start_at: iso });
      if (clear) setPresaleVal('');
      setPresaleSaved(true); setTimeout(() => setPresaleSaved(false), 2000);
      reload();
    } catch (e) { alert(e.message); }
  }

  async function applyGroup() {
    if (!groupSel) return;
    if (!window.confirm('Se crearán los lotes del grupo (pausados). Después activá los que correspondan. ¿Continuar?')) return;
    setApplying(true);
    try { await api.post(`/api/events/${event.id}/lots/from-group`, { group_id: groupSel }); setGroupSel(''); reload(); }
    catch (e) { alert(e.message); } finally { setApplying(false); }
  }

  return (
    <div className="lb-fade" style={{ paddingTop: 30 }}>
      {/* Inicio de venta (presale) */}
      <div className="lb-card" style={{ padding: '16px 20px', marginBottom: 18, display: 'flex', gap: 14, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div className="lb-eyebrow" style={{ marginBottom: 4 }}>Inicio de venta (presale)</div>
          <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>Hasta esa fecha y hora la web muestra <b>PRESALE</b> y una cuenta regresiva; al llegar el momento aparecen los lotes y el botón de compra. Dejalo vacío si la venta ya está abierta.</div>
        </div>
        <Field label="Fecha y hora">
          <input type="datetime-local" className="lb-input" value={presaleVal} onChange={e => setPresaleVal(e.target.value)} />
        </Field>
        <button className="lb-btn lb-btn--white lb-btn--sm" onClick={() => savePresale(false)}>{presaleSaved ? 'Guardado ✓' : 'Guardar'}</button>
        {event.sales_start_at && <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => savePresale(true)}>Quitar</button>}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div className="lb-eyebrow">Lotes y precios</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <select className="lb-select" style={{ padding: '8px 30px 8px 12px', fontSize: 13, minWidth: 180 }} value={groupSel} onChange={e => setGroupSel(e.target.value)}>
            <option value="">Usar grupo de lotes…</option>
            {groups.map(g => <option key={g.id} value={g.id}>{g.name} ({g.items?.length || 0})</option>)}
          </select>
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={applyGroup} disabled={!groupSel || applying}>{applying ? 'Aplicando…' : 'Aplicar grupo'}</button>
          <button className="lb-btn lb-btn--white lb-btn--sm" onClick={() => setEditing('new')}>+ Nuevo lote</button>
        </div>
      </div>

      <div className="lb-card tk-scroll-x" style={{ padding: '6px 24px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.6fr 0.9fr 0.9fr 24px' }}>
          <span>Lote</span><span>Vend. / Máx</span><span>Estado</span><span></span>
        </div>
        {lots.map(t => {
          const ch = Array.isArray(t.channels) ? t.channels : [];
          // Lo VENDIDO (venta al generar: incluye la capacidad de los links del RRPP
          // aunque todavía no hayan generado su QR). Es el número que se muestra.
          const sold = t.vendidas ?? t.sold_count ?? 0;
          // El cartel de AGOTADO va por `sold_count`, que es el contador que el sistema
          // usa de verdad para cortar la venta. Si fuera por `vendidas`, un lote podría
          // decir "Agotado" mientras el sistema sigue dejando generar links.
          const cupoUsado = t.sold_count || 0;
          const soldOut = t.status === 'sold_out' || (t.max_capacity > 0 && cupoUsado >= t.max_capacity);
          const on = t.status !== 'paused';
          return (
            <div key={t.id} className="lb-row lb-prodrow" onClick={() => setEditing(t)} style={{ gridTemplateColumns: '1.6fr 0.9fr 0.9fr 24px', opacity: on ? 1 : 0.5 }}>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 15, textTransform: 'uppercase', color: '#fff' }}>{t.name}</div>
                <div style={{ fontSize: 12, color: 'var(--ink-700)', marginTop: 2 }}>{money(t.price)}</div>
                <div style={{ display: 'flex', gap: 5, marginTop: 7, flexWrap: 'wrap' }}>
                  {ch.includes('rrpp') && <Chip>Tradicional</Chip>}
                  {ch.includes('online') && <Chip>Online</Chip>}
                  {t.es_consumicion ? <Chip>Consumición</Chip> : ch.includes('boleteria') && <Chip>Boletería</Chip>}
                  {t.roles === 'owners' && <Chip>Solo dueños</Chip>}
                </div>
              </div>
              {/* Primero lo vendido, que es el dato que se mira; el cupo va atrás como
                  referencia. */}
              <span style={{ color: 'var(--ink-800)', fontFamily: 'var(--font-display)', fontSize: 14 }}>{sold} <span style={{ color: 'var(--ink-600)' }}>/ {t.max_capacity > 0 ? t.max_capacity : '∞'}</span></span>
              <span>{soldOut ? <span className="lb-status lb-status--used">Agotado</span> : on ? <span className="lb-status lb-status--paid">Activo</span> : <span className="lb-status lb-status--gen">Pausado</span>}</span>
              <span style={{ color: 'var(--ink-600)', fontSize: 16, textAlign: 'right' }}>›</span>
            </div>
          );
        })}
        {lots.length === 0 && <div style={{ padding: '24px 0', textAlign: 'center', fontSize: 13, color: 'var(--ink-600)' }}>Sin lotes. Creá el primero.</div>}
      </div>
      <div style={{ marginTop: 10, fontSize: 11, color: 'var(--ink-600)' }}>Tocá un lote para editar precio, cupo, medio de venta, visibilidad y estado.</div>

      <ServiceFeeCard event={event} api={api} reload={reload} />

      {editing && <LotModal event={event} lot={editing === 'new' ? null : editing} api={api} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); reload(); }} />}
    </div>
  );
}

// Cargo por servicio en la venta ONLINE: % adicional que paga el comprador.
function ServiceFeeCard({ event, api, reload }) {
  const [pct, setPct] = useState(event.service_fee_pct == null ? '0' : String(Number(event.service_fee_pct)));
  const [saved, setSaved] = useState(false);
  async function save() {
    const v = Math.min(100, Math.max(0, Number(pct) || 0));
    try {
      await api.patch(`/api/events/${event.id}`, { service_fee_pct: v });
      setPct(String(v)); setSaved(true); setTimeout(() => setSaved(false), 2000);
      reload();
    } catch (e) { alert(e.message); }
  }
  return (
    <div className="lb-card" style={{ padding: '18px 22px', marginTop: 22 }}>
      <div className="lb-eyebrow" style={{ marginBottom: 6 }}>Cargos por servicio en la venta online</div>
      <div style={{ fontSize: 12, color: 'var(--ink-600)', lineHeight: 1.5, marginBottom: 14 }}>
        % adicional que se le suma al comprador en el checkout online (no aplica a la venta por RRPP). Vos elegís:
        <b style={{ color: 'var(--ink-800)' }}> 0%</b> → absorbés la tasa de la pasarela;
        <b style={{ color: 'var(--ink-800)' }}> un % mínimo</b> → cubrís esa tasa;
        <b style={{ color: 'var(--ink-800)' }}> 15% (como las ticketeras)</b> → te queda la diferencia.
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', width: 120 }}>
          <input className="lb-input" inputMode="decimal" value={pct}
            onChange={e => setPct(e.target.value.replace(/[^\d.]/g, '').slice(0, 6))}
            style={{ paddingRight: 28, textAlign: 'right' }} />
          <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-600)', fontSize: 14 }}>%</span>
        </div>
        <button className="lb-btn lb-btn--white lb-btn--sm" onClick={save}>{saved ? 'Guardado ✓' : 'Guardar'}</button>
      </div>
    </div>
  );
}

function Chip({ children }) {
  return <span style={{ fontFamily: 'var(--font-body)', fontWeight: 600, fontSize: 9, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-700)', border: '1px solid var(--border)', padding: '2px 7px', borderRadius: 999 }}>{children}</span>;
}

function LotModal({ event, lot, api, onClose, onSaved }) {
  const creating = !lot;
  const ch = lot && Array.isArray(lot.channels) ? lot.channels : ['online', 'rrpp'];
  const [f, setF] = useState({
    name: lot ? lot.name : '',
    price: lot ? String(lot.price) : '',
    max_capacity: lot ? String(lot.max_capacity) : '',
    tradicional: ch.includes('rrpp'),
    online: ch.includes('online'),
    boleteria: ch.includes('boleteria'),
    roles: lot ? (lot.roles || 'all') : 'all',
    status: lot ? (lot.status || 'active') : 'active', // active | paused | sold_out
    has_transport: lot ? !!lot.has_transport : false,
    solo_traslado: lot ? !!lot.solo_traslado : false,
    is_birthday: lot ? !!lot.is_birthday : false,
    es_consumicion: lot ? !!lot.es_consumicion : false,
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));
  // Boletería y ONLINE ahora conviven: vender online el mismo lote que se vende en la
  // puerta descomprime la boletería, y las dos ventas descuentan del mismo cupo.
  //
  // Lo que sigue siendo excluyente es boletería con RRPP ("tradicional"): el RRPP cobra
  // por adelantado y rinde por lo que GENERÓ, así que un lote que además se vende suelto
  // en la puerta no tiene forma de repartirse entre los dos. El backend también lo
  // rechaza, para que la regla no dependa de esta pantalla.
  const toggleTrad = () => setF(s => s.tradicional ? { ...s, tradicional: false } : { ...s, tradicional: true, boleteria: false });
  const toggleOnline = () => setF(s => ({ ...s, online: !s.online }));
  const toggleBoleteria = () => setF(s => s.boleteria ? { ...s, boleteria: false } : { ...s, boleteria: true, tradicional: false });
  // La consumición no es una entrada: solo boletería, sin traslado y sin lista de
  // cumpleaños. En vez de dejar elegir combinaciones que el backend rechaza, al
  // prenderla el lote queda configurado como lo único que puede ser.
  const toggleConsumicion = () => setF(s => s.es_consumicion
    ? { ...s, es_consumicion: false }
    : { ...s, es_consumicion: true, boleteria: true, tradicional: false, online: false, is_birthday: false, has_transport: false, solo_traslado: false });
  const valid = f.name.trim() && f.price !== '';

  async function save() {
    if (!valid) return;
    setSaving(true);
    const channels = [];
    if (f.tradicional) channels.push('rrpp');
    if (f.online) channels.push('online');
    if (f.boleteria) channels.push('boleteria');
    const body = {
      name: f.name.toUpperCase(), price: +f.price || 0, max_capacity: +f.max_capacity || 0,
      channels, roles: f.roles, status: f.status, has_transport: f.es_consumicion ? false : f.has_transport,
      solo_traslado: f.es_consumicion ? false : f.solo_traslado,
      is_birthday: (f.boleteria && !f.es_consumicion) ? f.is_birthday : false,
      es_consumicion: f.es_consumicion,
    };
    try {
      if (creating) await api.post(`/api/events/${event.id}/lots`, body);
      else await api.patch(`/api/events/${event.id}/lots/${lot.id}`, body);
      onSaved();
    } catch (e) { alert(e.message); } finally { setSaving(false); }
  }
  async function del() {
    if (!lot) return onClose();
    if (!window.confirm('¿Eliminar este lote?')) return;
    try { await api.del(`/api/events/${event.id}/lots/${lot.id}`); onSaved(); } catch (e) { alert(e.message); }
  }

  return (
    <div className="lb-modal-backdrop" onClick={onClose}>
      <div className="lb-modal" onClick={e => e.stopPropagation()}>
        <div style={{ padding: '24px 28px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div className="lb-eyebrow">{creating ? 'Nuevo lote' : 'Editar lote'}</div>
            <div className="lb-h" style={{ fontSize: 22, marginTop: 4 }}>{f.name || 'SIN NOMBRE'}</div>
          </div>
          <button className="lb-iconbtn" onClick={onClose}>✕</button>
        </div>

        <div style={{ padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <Field label="Nombre del lote"><input className="lb-input" value={f.name} onChange={e => set('name', e.target.value)} placeholder="LOTE 1" /></Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Field label="Precio" hint="$0 para invitación"><input className="lb-input" value={f.price} inputMode="numeric" onChange={e => set('price', e.target.value.replace(/\D/g, ''))} placeholder="0" /></Field>
            <Field label="Cupo máximo" hint="Vacío = ilimitado"><input className="lb-input" value={f.max_capacity} inputMode="numeric" onChange={e => set('max_capacity', e.target.value.replace(/\D/g, ''))} placeholder="Ilimitado" /></Field>
          </div>

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 18 }}>
            <div className="lb-label" style={{ marginBottom: 12 }}>Medio de venta</div>
            <Row title="Es consumición (no es entrada)" sub="Un vale para canjear en la barra: se cobra en boletería e imprime un comprobante sin QR. No da acceso, no cuenta como persona y no aparece en entradas vendidas."><Toggle on={f.es_consumicion} onClick={toggleConsumicion} label={f.es_consumicion ? 'Sí' : 'No'} /></Row>
            {!f.es_consumicion && <>
            <Row title="Tradicional" sub="Venta por RRPP / generación manual de QRs"><Toggle on={f.tradicional} onClick={toggleTrad} label={f.tradicional ? 'Sí' : 'No'} /></Row>
            <Row title="Online" sub="Compra desde la web pública"><Toggle on={f.online} onClick={toggleOnline} label={f.online ? 'Sí' : 'No'} /></Row>
            <Row title="Boletería" sub="Se vende en la caja de la puerta. Se puede combinar con Online (ayuda a descomprimir la boletería), pero no con RRPP."><Toggle on={f.boleteria} onClick={toggleBoleteria} label={f.boleteria ? 'Sí' : 'No'} /></Row>
            {f.boleteria && <Row title="Lista de cumpleaños" sub="Este es el lote gratis de cumpleañeros: en boletería se elige la persona de la lista y se emite su entrada"><Toggle on={f.is_birthday} onClick={() => set('is_birthday', !f.is_birthday)} label={f.is_birthday ? 'Sí' : 'No'} /></Row>}
            <Row title="Traslado" sub="Combo = entrada + traslado (dos QR). Solo Trasl. = se vende el traslado sin entrada; no cuenta como persona y no va en boletería">
              <div style={{ display: 'flex', gap: 6 }}>
                {[['no', 'Sin traslado'], ['combo', 'Combo'], ['solo', 'Solo Trasl.']].map(([k, t]) => (
                  <button key={k} type="button" className={'lb-btn lb-btn--sm ' + (modoTraslado(f) === k ? 'lb-btn--white' : 'lb-btn--ghost')}
                    onClick={() => setModoTraslado(set, k)}>{t}</button>
                ))}
              </div>
            </Row>
            </>}
          </div>

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 18 }}>
            <div className="lb-label" style={{ marginBottom: 10 }}>Quién puede generarlo</div>
            <div style={{ display: 'flex', gap: 10 }}>
              {[['all', 'Dueños y vendedores'], ['owners', 'Solo dueños']].map(([v, lbl]) => (
                <button key={v} onClick={() => set('roles', v)} style={{ flex: 1, cursor: 'pointer', padding: '12px 14px', textAlign: 'left', background: f.roles === v ? 'rgba(255,255,255,0.05)' : 'var(--ink-050)', border: '1px solid ' + (f.roles === v ? 'rgba(255,255,255,0.5)' : 'var(--border)'), color: f.roles === v ? '#fff' : 'var(--ink-700)', fontWeight: 600, fontSize: 12.5, borderRadius: 4 }}>{lbl}</button>
              ))}
            </div>
          </div>

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 18 }}>
            <div className="lb-label" style={{ marginBottom: 10 }}>Estado del lote</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                ['active', 'Activo', 'Visible y a la venta'],
                ['sold_out', 'Agotado', 'Se muestra con la leyenda AGOTADO, pero no se puede comprar'],
                ['paused', 'Pausado', 'Oculto de la web (no aparece)'],
              ].map(([v, lbl, sub]) => {
                const on = f.status === v;
                return (
                  <button key={v} type="button" onClick={() => set('status', v)} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', textAlign: 'left', background: on ? 'rgba(255,255,255,0.05)' : 'var(--ink-050)', border: '1px solid ' + (on ? 'rgba(255,255,255,0.5)' : 'var(--border)'), padding: '11px 13px', borderRadius: 4 }}>
                    <span style={{ width: 14, height: 14, flex: 'none', borderRadius: 999, border: '1px solid ' + (on ? 'var(--red-500)' : 'var(--ink-500)'), display: 'grid', placeItems: 'center' }}>{on && <span style={{ width: 7, height: 7, borderRadius: 999, background: 'var(--red-500)' }} />}</span>
                    <span>
                      <span style={{ display: 'block', color: on ? '#fff' : 'var(--ink-800)', fontWeight: 600, fontSize: 13 }}>{lbl}</span>
                      <span style={{ display: 'block', fontSize: 11, color: 'var(--ink-600)' }}>{sub}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div style={{ padding: '18px 28px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: 12, alignItems: 'center' }}>
          {!creating && <button className="lb-iconbtn" onClick={del} style={{ width: 'auto', padding: '0 12px', height: 38 }}>Eliminar</button>}
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={onClose} style={{ marginLeft: 'auto' }}>Cancelar</button>
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={!valid || saving}>Guardar</button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, hint, children }) {
  return <div className="lb-field"><div className="lb-label">{label}</div>{children}{hint && <div className="lb-hint">{hint}</div>}</div>;
}

// ISO (instante) -> string para <input datetime-local> en hora local del navegador.
function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
function Row({ title, sub, children, top }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: top ? 0 : 12, borderTop: top ? '1px solid rgba(255,255,255,0.08)' : 0, paddingTop: top ? 18 : 0 }}>
      <div><div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>{title}</div><div style={{ fontSize: 11, color: 'var(--ink-600)' }}>{sub}</div></div>
      {children}
    </div>
  );
}
